module.exports = "<div *ngIf=\"displayError\">\r\n  <alert type=\"danger\" *ngFor=\"let error of errorMsg\">\r\n    {{ error }}\r\n  </alert>\r\n</div>"